import { APIError } from "../core/errors";
import {
  postApi,
  getApi,
  postApiErrorAdmin,
  getApiErrorAdmin,
  getApiErrorMypage,
  postApiErrorMypage,
} from "../utils/common";

// 取得単位数集計期間取得
export const getPeriodMaster = async () => {
  const urlPath = "/api/admin/courselist/period/?";
  try {
    const json = await getApi(urlPath);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, "");
  }
};

// 講座一覧データ取得
export const getCourseList = async (searchCondition, offsetNum, siteId) => {
  const urlPath = "/api/admin/courselist/?";
  const searchParams = new URLSearchParams({
    ...searchCondition,
    offset_num: offsetNum,
    site_id: siteId,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 管理画面-講座申込情報csvアップロード
export const postUploadCourseApplicant = async (data) => {
  const urlPath = "/api/admin/course/courseapplicantupload";
  const postData = data;
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 管理画面-学生毎の期間内合計単位数情報取得
export const getUnitSumList = async (searchCondition) => {
  const urlPath = "/api/admin/course/unitsumlist/?";
  const searchParams = new URLSearchParams({
    ...searchCondition,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 講座詳細データ取得
export const getCourse = async (id) => {
  const urlPath = "/api/admin/course/?";
  const searchParams = new URLSearchParams(id);
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 講座申込データ一覧取得
export const getCourseApplicantList = async (id, searchCondition) => {
  const urlPath = "/api/admin/courseapplicantlist/?";
  const searchParams = new URLSearchParams({ ...id, ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 講座申込データ一括更新
export const postUpdateBrkCourseApplicantList = async (data) => {
  const urlPath = "/api/admin/courseapplicantlist/update/";
  const postData = { ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 抽選
export const postLottery = async (id, data) => {
  const urlPath = "/api/admin/courseapplicantlist/lottery/";
  const postData = { id: id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 新規講座申込-学生一覧取得
export const getCourseApplicantStudentList = async (id, searchCondition) => {
  const urlPath = "/api/admin/addcourseapplicant/studentlist/?";
  const searchParams = new URLSearchParams({ ...id, ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 新規講座申込
export const postAddCourseApplicant = async (course_id, data) => {
  const urlPath = "/api/admin/addcourseapplicant/add/";
  const postData = { course_id: course_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 講座申込更新
export const postUpdateCourseApplicant = async (course_id, user_id, data) => {
  const urlPath = "/api/admin/courseapplicantdetail/update/";
  const postData = { course_id: course_id, user_id: user_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// 申込者詳細データ取得
export const getCourseApplicantDetail = async (id, user_id, is_edit = 0) => {
  const urlPath = "/api/admin/courseapplicantdetail/?";
  const searchParams = new URLSearchParams({
    id: id,
    user_id: user_id,
    is_edit: is_edit,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorAdmin(e, urlPath, searchParams);
  }
};

// 講座キャンセル
export const postCancelCourseApplicant = async (course_id, user_id, data) => {
  const urlPath = "/api/admin/courseapplicantdetail/cancel/";
  const postData = { course_id: course_id, user_id: user_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorAdmin(e, urlPath, postData);
  }
};

// マイページ-申込状況・受講履歴
export const getMypageCourseApplicantList = async (searchCondition) => {
  const urlPath = "/api/mypage/courselist/?";
  const searchParams = new URLSearchParams({ ...searchCondition });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-講座一覧データ取得
export const getMypageCourseList = async (searchCondition, url) => {
  const urlPath = "/api/mypage/" + url + "courselist/?";
  const searchParams = new URLSearchParams({
    ...searchCondition,
  });
  try {
    const json = await getApi(urlPath + searchParams);
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-講座詳細用に申込状況を取得
export const getMypageCourseApplicant = async (course_id) => {
  const urlPath = "/api/mypage/course/?";
  const searchParams = new URLSearchParams(course_id);
  try {
    const json = await getApi(urlPath + searchParams);
    if (Object.keys(json).length < 1) {
      throw new APIError("API Error", { status: 404 });
    }
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-講座申込
export const postCourseApplication = async (course_id, data) => {
  const urlPath = "/api/mypage/courseapplication/";
  const postData = { course_id: course_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};

// マイページ-講座キャンセル用にユーザ情報を取得
export const getMypageCourseApplicantUser = async (course_id) => {
  const urlPath = "/api/mypage/coursecancel/?";
  const searchParams = new URLSearchParams(course_id);
  try {
    const json = await getApi(urlPath + searchParams);
    if (Object.keys(json).length < 1) {
      throw new APIError("API Error", { status: 404 });
    }
    return json;
  } catch (e) {
    getApiErrorMypage(e, urlPath, searchParams);
  }
};

// マイページ-講座キャンセル
export const postMypageCancelCourse = async (course_id, data) => {
  const urlPath = "/api/mypage/coursecancel/cancel";
  const postData = { course_id: course_id, ...data };
  try {
    const json = await postApi(urlPath, postData);
    return json;
  } catch (e) {
    postApiErrorMypage(e, urlPath, postData);
  }
};
